import User from 'modules/Auth/common/User.interface';
import collectiveApi from 'modules/common/collectiveApi';

const fetchUser = async () => {
    const response = await collectiveApi.get<User>('rest-auth/user/');
    return response.data;
};

export default fetchUser;
